module.exports = __webpack_public_path__ + "img/76_30.8fbb013d.png";